import {
  Flex,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useContext, useState } from "react";

const imageModalContext = React.createContext<any>(null);

export default function ImageModalProvider({ children }: any) {
  const imageModal = useDisclosure();
  const [file, setFile] = useState<any>();
  function open(file: any) {
    setFile(file);
    imageModal.onOpen();
  }

  return (
    <imageModalContext.Provider value={{ open }}>
      <Modal isOpen={imageModal.isOpen} onClose={imageModal.onClose}>
        <ModalOverlay />
        <ModalContent
          onClick={imageModal.onClose}
          boxShadow="none"
          height="80vh"
          bg="rgba(0,0,0,0.4)"
        >
          <Flex justifyContent="center" alignItems="center" height="100%">
            hi
            {file?.url && (
              <Image
                src={file.url}
                maxH={"80vh"}
                width="auto"
                fallbackSrc={`https://via.placeholder.com/150/?text=${file.name
                  .split(".")[1]
                  .toUpperCase()}`}
              />
            )}
          </Flex>
        </ModalContent>
      </Modal>
      {children}
    </imageModalContext.Provider>
  );
}

export function useImageModal() {
  return useContext(imageModalContext);
}
